import { render, staticRenderFns } from "./buySuccess.vue?vue&type=template&id=6834a33f&"
import script from "./buySuccess.vue?vue&type=script&lang=js&"
export * from "./buySuccess.vue?vue&type=script&lang=js&"
import style0 from "./buySuccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports